import {DunningData} from '../model/dunning-data.interface';

/**
 * Mock Dunning Data Set 1 - Example from requirements
 * Customer with 4 contracts (A, B, C in dunning, D is new)
 * Total dunning amount: 147.78 EUR + 80 EUR charges = 227.78 EUR
 */
export const MOCK_DUNNING_DATA_4: DunningData = {
  customerId: 10004,
  customerBillingAccountId: 20004,
  dunningId: 30004,
  contracts: [
    {
      identifier: '82889292',
      partner: 'Allianz',
      type: 'Health Insurance',
      monthlyPrice: [
        {
          startMonth: '2025-01',
          monthlyPrice: 37.22
        },
        {
          startMonth: '2025-06',
          monthlyPrice: 40.22
        },
        {
          startMonth: '2026-01',
          monthlyPrice: 45.22
        },
        {
          startMonth: '2026-06',
          monthlyPrice: 47.22
        }
      ],
      currency: 'EUR',
      dunningMonths: 3,
      reactivationMonths: 5,
      dunningAmount: 111.66,
      reactivationAmount: 186.10,
      status: 'in-dunning'
    },
    {
      identifier: '82889293',
      partner: 'DKV',
      type: 'Dental Insurance',
      monthlyPrice: [
        {
          startMonth: '2025-01',
          monthlyPrice: 7.31
        },
        {
          startMonth: '2025-06',
          monthlyPrice: 9.31
        },
        {
          startMonth: '2026-01',
          monthlyPrice: 11.31
        }
      ],
      currency: 'EUR',
      dunningMonths: 3,
      reactivationMonths: 5,
      dunningAmount: 21.93,
      reactivationAmount: 37.55,
      status: 'in-dunning'
    },
    {
      identifier: '82889294',
      partner: 'Gothaer',
      type: 'Life Insurance',
      monthlyPrice: [
        {
          startMonth: '2025-01',
          monthlyPrice: 4.73
        },
        {
          startMonth: '2025-06',
          monthlyPrice: 6.73
        },
        {
          startMonth: '2026-01',
          monthlyPrice: 8.73
        }
      ],
      currency: 'EUR',
      dunningMonths: 3,
      reactivationMonths: 5,
      dunningAmount: 14.19,
      reactivationAmount: 23.65,
      status: 'in-dunning'
    },
    {
      identifier: '82889295',
      partner: 'Axa',
      type: 'Accident Insurance',
      monthlyPrice: [
        {
          startMonth: '2026-01',
          monthlyPrice: 10.00
        }
      ],
      currency: 'EUR',
      dunningMonths: 0,
      reactivationMonths: 0,
      dunningAmount: 0,
      reactivationAmount: 0,
      status: 'new'
    }
  ],
  charges: [
    {
      name: 'Lawyer Fees',
      amount: 80.00,
      currency: 'EUR',
      deductable: true,
      reducable: true
    },
    {
      name: 'BLR',
      amount: 20.00,
      currency: 'EUR',
      deductable: true,
      reducable: false
    },
    {
      name: 'Company Fees',
      amount: 30.00,
      currency: 'EUR',
      deductable: false,
      reducable: true
    },
    {
      name: 'Late Fees',
      amount: 50.00,
      currency: 'EUR',
      deductable: false,
      reducable: false
    }
  ]
};
